import styled from "@emotion/styled";
import { Paper } from "@mui/material";

export const CreateQuotePageContainer = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.backgroundColors.tertiary,
	padding: "16px 20px",
	display: "flex",
	gap: "16px",
	flexDirection: "column"
}));

export const CreateQuoteHeaderContainer = styled.div(({ theme }) => ({
	width: "100%",
	backgroundColor: theme.project.colors.backgroundColors.main,
	padding: "20px 36px",
	display: "flex",
	flexDirection: "column",
	boxSizing: "border-box",
	gap: 16,
	position: "sticky",
	zIndex: 998,
	"> span": {
		height: 24
	},
	"> button": {
		width: 115
	},
	[theme.breakpoints.down("lg")]: {
		top: 56
	}
}));

export const CreateQuoteHeaderHeadContainer = styled.div(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	h4: {
		margin: 0
	},
	"> span": {
		height: 42,
		width: "50%"
	},
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		alignItems: "flex-start",
		gap: 24,
		"> span": {
			width: "100%"
		}
	}
}));

export const DesignerRequestFormContainer = styled(Paper)(({ theme }) => ({
	border: `1px solid ${theme.palette.divider}`,
	display: "flex",
	flexDirection: "column"
}));

export const DesignerRequestFormAccountAndBillToContainer = styled.div(({ theme }) => ({
	backgroundColor: theme.project.colors.allColors.hex.grayscale.gray200,
	borderBottom: `1px solid ${theme.palette.divider}`,
	display: "flex",
	flexDirection: "row",
	padding: 16,
	gap: 16,
	[theme.breakpoints.down("sm")]: {
		flexDirection: "column"
	}
}));

export const DesignerRequestSKUContainer = styled.div({
	display: "flex",
	flexDirection: "column",
	padding: 16,
	gap: 16
});

export const DesignerCustomizationDesignerRequestSKUTitle = styled.div(({ theme }) => ({
	...theme.project.typography.heading.h6,
	color: theme.project.colors.fontColors.main
}));

export const DesignerCustomizationDesignerRequestSKUSubtitle = styled.div(({ theme }) => ({
	...theme.project.typography.overline,
	color: theme.project.colors.fontColors.secondary
}));

export const DesignerRequestBaseSKUContainer = styled.div(({ theme }) => ({
	border: `1px solid ${theme.palette.divider}`,
	display: "flex",
	flexDirection: "column",
	padding: 16,
	gap: 16,
	h6: {
		...theme.project.typography.heading.h6,
		margin: 0
	},
	form: {
		div: {
			margin: 0
		}
	}
}));

export const DesignerCustomizationDetailsFormContainer = styled(Paper)(({ theme }) => ({
	border: `1px solid ${theme.palette.divider}`,
	display: "flex",
	flexDirection: "column",
	padding: "16px",
	gap: 16
}));

export const DesignerCustomizationDetailsFormHeader = styled.div(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle1,
	color: theme.project.colors.fontColors.secondary
}));

export const TopBarContainer = styled.div(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	gap: "12px",
	[theme.breakpoints.down("md")]: {
		flexDirection: "column-reverse",
		alignItems: "flex-start"
	}
}));

export const RequiredFieldText = styled.div(({ theme }) => ({
	...theme.project.typography.caption,
	color: theme.project.colors.fontColors.secondary
}));

export const LinkContainer = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "flex-end",
	alignItems: "center",
	gap: "20px",
	[theme.breakpoints.down("md")]: {
		flexDirection: "column",
		alignItems: "flex-start",
		gap: 0
	}
}));

export const LinkTitle = styled.h3(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle2,
	color: theme.project.colors.primaryColors.main,
	margin: 0,
	fontSize: "16px"
}));

export const ResourceLink = styled.a(({ theme }) => ({
	...theme.project.typography.body.body2,
	color: theme.project.colors.primaryColors.main,
	textDecoration: "underline",
	cursor: "pointer",
	fontSize: "16px",
	"&:hover": {
		textDecoration: "underline"
	}
}));

export const DesignerCustomizationDetailsFormContentContainer = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: 24
});

export const OrderDetailsFormContainer = styled(Paper)(({ theme }) => ({
	border: `1px solid ${theme.palette.divider}`,
	display: "flex",
	flexDirection: "column",
	padding: "16px",
	gap: 16
}));

export const OrderDetailsFormHeader = styled.div(({ theme }) => ({
	...theme.project.typography.subtitle.subtitle1,
	color: theme.project.colors.fontColors.secondary
}));

export const DesignerNumberContainer = styled.div(({ theme }) => ({
	display: "flex",
	flexDirection: "row",
	gap: 10,
	"& > *": {
		width: "50%"
	},
	[theme.breakpoints.down("sm")]: {
		flexDirection: "column",
		"& > *": {
			width: "100%"
		}
	}
}));

export const DesignerInfoDesignerContainer = styled.div({
	display: "flex",
	flexDirection: "column",
	gap: 24
});

export const SubmitButtonContainer = styled.div(({ theme }) => ({
	display: "flex",
	justifyContent: "flex-end",
	[theme.breakpoints.down("sm")]: {
		justifyContent: "stretch",
		"& button": {
			width: "100%"
		}
	}
}));

export const ErrorHelperTextContainer = styled.span({
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	width: "100%"
});

export const ErrorMessageContainer = styled.span({
	display: "flex",
	alignItems: "center",
	gap: "4px"
});

export const CharacterCountError = styled.span(({ theme }) => ({ color: theme.project.colors.semanticColors.error }));

export const SimpleErrorContainer = styled.span({
	display: "flex",
	alignItems: "center",
	gap: "4px"
});

export const RightAlignedFormHelperTextProps = {
	sx: { textAlign: "right" as const }
};
